import { type LinearConfiguratorState } from "../redux/types";
import { type LinearConfiguration } from "../models";
import { prepareCommonLinearData, sendLinear } from "./sendLinearCommon";
import { prepareApiDataForResetNewest, prepareGroupIdToDisplay } from "../../common/commonConfiguratorApi";

export function sendLinearDataReset(linearState: LinearConfiguratorState): Promise<LinearConfiguration> {
  const data = prepareCommonLinearData(linearState);
  // TODO: Check if reset in all steps works correctly after this change
  const resetData = prepareApiDataForResetNewest(linearState);

  prepareGroupIdToDisplay(data);

  return sendLinear({
    ...data,
    ...resetData,
  });
}
